<template>
  <v-card
    outlined
    elevation="4"
    class="d-flex flex-column pa-2 mt-5"
  >
    <v-btn
      class="align-self-end"
      color="primary"
      outlined
      target="_blank"
      :href="linkTemplateExemplo"
    >
      Download template e-mail de exemplo
    </v-btn>

    <v-file-input
      ref="inputTemplateEmailRef"
      class="mt-3"
      show-size
      validate-on-blur
      label="Importar template de email"
      accept=".htm, .html"
      :rules="[v => !!v || 'Template de email é obrigatório']"
      @change="uploadTemplate"
    />
  </v-card>
</template>

<script>
import { ref, watchEffect } from '@vue/composition-api'
import { mdiClose } from '@mdi/js'

export default {
  props: {
    template: {
      type: String,
      default: null,
    },
  },

  setup(props, { emit }) {
    const inputTemplateEmailRef = ref(null)
    const templateLocale = ref('')
    watchEffect(() => { templateLocale.value = props.template })

    function uploadTemplate(file) {
      if (!file) return
      const reader = new FileReader()
      reader.readAsBinaryString(file)
      reader.onload = () => {
        const content = reader.result
        templateLocale.value = content
        emit('update:template', templateLocale.value)
      }
    }

    const linkTemplateExemplo = 'https://vikdocumentdb.blob.core.windows.net/utils/TemplateBotaoEnvioEmail.txt?sv=2021-10-04&st=2023-02-08T17%3A20%3A50Z&se=2030-02-09T17%3A20%3A00Z&sr=b&sp=r&sig=KNTyKA6nqb20aGshwHUGW84myJzGnZV8QPXCtPmnxqE%3D'

    return {
      inputTemplateEmailRef,
      templateLocale,
      uploadTemplate,
      icons: {
        mdiClose,
      },
      linkTemplateExemplo,
    }
  },
}
</script>
